import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, Globe, Users } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-4 pb-6 px-4 relative overflow-hidden" data-id="element-115">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-116">
        <div className="inline-block bg-brand-accent text-brand-dark font-black px-3 py-1 rounded-full mb-3 text-[10px] md:text-xs tracking-widest uppercase shadow-[0_0_15px_rgba(200,255,0,0.3)]" data-id="element-117">
          🏋️ MEGAPACK ENTRENAMIENTO FUNCIONAL
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-black mb-2 leading-tight text-white tracking-tight" data-id="element-118">
          Todo tu año de entrenamiento resuelto.
        </h1>

        <h2 className="text-sm md:text-lg lg:text-xl font-black mb-2 text-brand-accent neon-glow uppercase tracking-wide" data-id="element-119">
          Megapack Entrenamiento Funcional — Combo Completo
        </h2>

        <p className="text-sm md:text-base font-bold text-gray-300 mb-4 italic" data-id="element-120">
          "Listo para usar. Sin improvisar más."
        </p>

        <div className="w-full max-w-[280px] md:max-w-sm mx-auto mb-4 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 relative" onClick={scrollToCompra} data-id="element-121">
          <div className="absolute inset-0 bg-brand-accent/10 blur-3xl rounded-full" data-id="element-122"></div>
          <img src="https://cdn.magicpatterns.com/uploads/bv8Df7mdeHNyYjz6QM7CSX/mockups_FUNCIONAL_.png" alt="Kit Completo Entrenamiento Funcional" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-123" />
        </div>

        <p className="text-xs md:text-sm mb-4 font-medium text-gray-400 max-w-lg mx-auto leading-snug" data-id="element-124">
          Planificá todo tu año en una tarde — sin improvisar ni perder fines de
          semana buscando material.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-3 mb-4 w-full" data-id="element-125">
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs font-medium" data-id="element-126">
            <FileText className="w-3 h-3 mr-1 text-brand-accent" data-id="element-127" />
            <span data-id="element-128">100% PDF</span>
          </div>
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs font-medium" data-id="element-129">
            <Zap className="w-3 h-3 mr-1 text-brand-accent" data-id="element-130" />
            <span data-id="element-131">Acceso inmediato</span>
          </div>
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs font-medium" data-id="element-132">
            <Globe className="w-3 h-3 mr-1 text-brand-accent" data-id="element-133" />
            <span data-id="element-134">Toda Latinoamérica</span>
          </div>
          <div className="flex items-center bg-white/5 px-2 py-1 rounded-full border border-white/10 text-[10px] md:text-xs font-medium" data-id="element-135">
            <Users className="w-3 h-3 mr-1 text-brand-accent" data-id="element-136" />
            <span data-id="element-137">Todos los niveles</span>
          </div>
        </div>

        <div className="w-full max-w-sm mx-auto mb-3" data-id="element-138">
          <Button className="text-base md:text-xl py-3 md:py-4 shadow-[0_0_30px_rgba(200,255,0,0.3)]" data-id="element-139">
            🏋️ → QUIERO MI KIT AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-140">
          <div className="flex items-center" data-id="element-141">
            <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-142" />
            <span data-id="element-143">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-144">
            <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-145" />
            <span data-id="element-146">Pago seguro</span>
          </div>
          <div className="flex items-center" data-id="element-147">
            <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-148" />
            <span data-id="element-149">Tu moneda local</span>
          </div>
        </div>
      </div>
    </section>;
}